import {Component, HostBinding, Input} from '@angular/core';
import {DataGridService} from '../../data-grid.service';
import {DataGridSort} from '../../data-grid-sort/data-grid-sort';

@Component({
    selector: 'vui-data-grid-group',
    templateUrl: './data-grid-group.component.html',
    styleUrls: ['./data-grid-group.component.scss']
})
export class DataGridGroupComponent {
    public dataGridSort: DataGridSort;
    @Input() public name: string;
    @HostBinding('style.column-span') @Input() public span: string;
    @Input() public title: string;

    constructor(private dataGridService: DataGridService) {
        this.dataGridService.sort$.subscribe((dataGridSort) => {
            this.dataGridSort = dataGridSort;
        });
        this.name = this.title;
    }

    /**
     *
     */
    public sorted(): boolean {
        if (this.dataGridSort) {
            if (this.dataGridSort.name) {
                return this.dataGridSort.name.includes(this.name);
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public toggle(): void {
        if (this.sorted()) {
            if (this.dataGridSort.order === 'ascending') {
                this.dataGridService.sort$.next(new DataGridSort({
                    name: this.name,
                    order: 'descending'
                }));
            } else {
                this.dataGridService.sort$.next(new DataGridSort({
                    name: this.name,
                    order: 'ascending'
                }));
            }
        } else {
            this.dataGridService.sort$.next(new DataGridSort({
                name: this.name,
                order: 'ascending'
            }));
        }
    }
}
